import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as dashboardActions from '../../../pillar/dashboard/store/actions';
import * as userActions from '../actions';
import { ModuleConfiguration } from '../../customer.module.config';
import { UserListModel } from '../../models/UserListModel';
import { UserModel } from '../../models/UserModel';
import { UserGroupModel } from '../../models/UserGroupModel';
import { UserState } from '../state/UserState';
import { RoleModel } from '../../../security/models/RoleModel';
import { AddUserModel } from '../../models/AddUserModel';

var tileStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, UserListModel, UserModel, new TileState<UserListModel, UserModel>());

function roleSort(a: RoleModel, b: RoleModel): number {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

export function userReducer(state = new UserState, action: dashboardActions.Actions<UserModel | UserGroupModel>): UserState {
  var selected = state.selected;
  var list = state.list;
  var index = undefined;
  switch (action.type) {
    case dashboardActions.querySuccessType(ModuleConfiguration.moduleName, UserGroupModel):
      return {
        ...state,
        groupLookups: (action as any).payload.items
      };
    case dashboardActions.addType(ModuleConfiguration.moduleName, AddUserModel):
      return {
        ...state,
        loading: true,
        errors: []
      };
    case dashboardActions.addSuccessType(ModuleConfiguration.moduleName, AddUserModel):
      return {
        ...state,
        loading: false
      };
    case userActions.GET_NOTIFICATION_TYPES_SUCCESS:
      return {
        ...state,
        notificationTypes: (action as userActions.GetNotificationTypesSuccessAction).payload.notificationTypes
      };
    case userActions.ADD_ROLE_TO_USER_SUCCESS:
      var addAction = action as userActions.AddRoleToUserSuccessAction;
      if (state.selected.key === addAction.payload.userKey) {
        var addedRole = addAction.payload.role;
        return {
          ...state,
          selected: {
            ...state.selected,
            roles: state.selected.roles.concat([addedRole]).sort(roleSort)
          }
        }
      }
    case userActions.REMOVE_ROLE_FROM_USER_SUCCESS:
      var removeAction = action as userActions.RemoveRoleFromUserSuccessAction;
      if (state.selected.key === removeAction.payload.userKey) {
        var removedRole = removeAction.payload.role;
        return {
          ...state,
          selected: {
            ...state.selected,
            roles: state.selected.roles.filter(r => r.key !== removedRole.key).sort(roleSort)
          }
        }
      }
    case userActions.LOCK_ACCOUNT_SUCCESS:
      var lockAction = action as userActions.LockAccountSuccessAction;
      if (state.selected && state.selected.key === lockAction.payload.user.key) {
        selected = {
          ...state.selected,
          isLocked: true,
          lockReason: lockAction.payload.user.reason,
          status: lockAction.payload.status
        }
      }
      var userList = state.list.find(u => u.key === lockAction.payload.user.key);
      if (userList) {
        index = list.indexOf(userList);
        var newUserList = {
          ...userList,
          isLocked: true,
          lockReason: lockAction.payload.user.reason,
          status: lockAction.payload.status
        }
        list.splice(index, 1, newUserList);
      }
      return {
        ...state,
        selected: selected,
        list: list.slice(0)
      };
    case userActions.DISABLE_ACCOUNT_SUCCESS:
      var disableAction = action as userActions.DisableAccountSuccessAction;
      if (state.selected && state.selected.key === disableAction.payload.user.key) {
        selected = {
          ...state.selected,
          status: disableAction.payload.status,
          isDisabled: true
      }
      }
      var userListDisable = state.list.find(u => u.key === disableAction.payload.user.key);
      if (userListDisable) {
        index = list.indexOf(userListDisable);
        var newUserListDisable = {
          ...userListDisable,
          status: disableAction.payload.status,
          isAccountDisabled: true
        }
        list.splice(index, 1, newUserListDisable);
      }
      return {
        ...state,
        selected: selected,
        list: list.slice(0)
      };
    case userActions.UNLOCK_ACCOUNT_SUCCESS:
      var unlockAction = action as userActions.UnlockAccountSuccessAction;
      if (state.selected && state.selected.key === unlockAction.payload.user.key) {
        selected = {
          ...state.selected,
          isLocked: false,
          status: unlockAction.payload.status
        }
      }
      var matchedUser = state.list.find(u => u.key === unlockAction.payload.user.key);
      if (matchedUser) {
        index = list.indexOf(matchedUser);
        var newMatchedUser = {
          ...matchedUser,
          isLocked: false,
          status: unlockAction.payload.status
        }
        list.splice(index,1,newMatchedUser);
      }
      return {
        ...state,
        selected: selected,
        list: list.slice(0)
      };
    case userActions.ENABLE_ACCOUNT_SUCCESS:
      var enableAction = action as userActions.EnableAccountSuccessAction;
      if (state.selected && state.selected.key === enableAction.payload.user.key) {
        selected = {
          ...state.selected,
          status: enableAction.payload.status,
          isDisabled: false
        }
      }
      var matchedUserEnable = state.list.find(u => u.key === enableAction.payload.user.key);
      if (matchedUserEnable) {
        index = list.indexOf(matchedUserEnable);
        var newMatchedUserEnable = {
          ...matchedUserEnable,
          status: enableAction.payload.status,
          isAccountDisabled: false
        }
        list.splice(index, 1, newMatchedUserEnable);
      }
      return {
        ...state,
        selected: selected,
        list: list.slice(0)
      };
    case userActions.RESET_PASSWORD_SUCCESS:
      var resetPasswordAction = (action as userActions.ResetPasswordSuccessAction);
      if (state.selected && state.selected.key === resetPasswordAction.payload.user.key) {
        selected = {
          ...state.selected,
          status: 'Active'
        }
      }
      var resetList = state.list.find(u => u.key === resetPasswordAction.payload.user.key);
      if (resetList) {
        index = list.indexOf(resetList);
        var newReset = {
          ...resetList,
          status: 'Active'
        }
        list.splice(index, 1, newReset);
      }
      return {
        ...state,
        selected: selected,
        list: list.slice(0)
      };
    case userActions.GET_USER_SUBMITTING_ENTITIES_SUCCESS:
      var getUserSubmittingEntitiesSuccessAction = (action as userActions.GetUserSubmittingEntitiesSuccessAction);
      if (state.selected && state.selected.key === getUserSubmittingEntitiesSuccessAction.payload.userKey) {
        return {
          ...state,
          selectedUserAssociatedSubmittingEntities: getUserSubmittingEntitiesSuccessAction.payload.submittingEntities
        };
      }
      return state;
    case userActions.GET_USER_CURRENT_STATUS_SUCCESS:
      var getUserCurrentStatusSuccessAction = (action as userActions.GetUserCurrentStatusSuccessAction);
      if (state.selected && state.selected.key === getUserCurrentStatusSuccessAction.payload.userKey) {
        return {
          ...state,
          status: getUserCurrentStatusSuccessAction.payload.userCurrentStatus
        };
      }
      return state;
    case dashboardActions.getClearSelectionType(ModuleConfiguration.moduleName, UserModel):
      return {
        ...state,
        selected: null,
        selectedUserAssociatedSubmittingEntities: []
      };
    case userActions.CHECK_GLOBAL_LOCK_SUCCESS:
      var checkAction = (action as userActions.CheckGlobalLockSuccessAction);
      return {
        ...state,
        globalLockStatus: checkAction.payload.active
      }
    case userActions.GLOBAL_LOCK_SUCCESS:
      return {
        ...state,
        globalLockStatus: true
      }
    case userActions.GLOBAL_UNLOCK_SUCCESS:
      return {
        ...state,
        globalLockStatus: false
      }
    default:
      return tileStateReducer(state, action) as UserState;
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/reducers/user.reducer.ts